<div class="flex flex-col justify-center items-center rounded-10 gap-5">
  <div
    class="h-5 w-20 mb-3 max-sm:mb-0 rounded-5 animate-pulse bg-[#DDDEE0]"
  ></div>

  <div class="w-full flex flex-col gap-1 max-sm:gap-1">
    @for(_ of [].constructor(18); track $index) {
    <div
      class="h-12 max-sm:h-8 w-full rounded-5 animate-pulse bg-[#DDDEE0]"
    ></div>
    }
  </div>

  <div class="w-full p-5 flex flex-col gap-3 max-sm:gap-1">
    @for(_ of [].constructor(3); track $index) {
    <div
      class="h-12 max-sm:h-8 w-full rounded-5 animate-pulse bg-[#DDDEE0]"
    ></div>
    }
  </div>
</div>
